
  import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
  import {Chart} from 'chart.js';
  import {Router} from '@angular/router';
  import {Store} from '@ngrx/store';
  import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
  import {DoctorService} from '../../../../services/doctor.service';
  import {MatDialog} from '@angular/material/dialog';
  import {Observable, Subscription} from 'rxjs';
  import {MatTableDataSource} from '@angular/material/table';
  import {Patient} from '../../../../model/user/Patient';
  import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
  import {MatCheckboxChange} from '@angular/material/checkbox';
  import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-inactive-activetherapy',
  templateUrl: './bar-chart-inactive-activetherapy.component.html',
  styleUrls: ['./bar-chart-inactive-activetherapy.component.css']
})
export class BarChartInactiveActivetherapyComponent implements OnInit {

    
            // per inizializzazione
            getAuthState: Observable<any>;
            getDoctorState: Observable<any>;
            isAuthenticated: boolean;
            user = null;
            errorMessage = null;
            subscription1: Subscription;
            subscription2: Subscription;
            subscription3: Subscription;
            subscription4: Subscription;
            subscription5: Subscription;
            subscription6: Subscription;
            subscription7: Subscription;
            title = 'Terapia attiva';
            destination = 'inactive';


  
            // elementi che servono per il bar-chart
            canvas: any;
            ctx: any;
            myChartInactivePatients: Chart;
      
            // ******************************************************************************************************************
            // seguenti righe: inizializzazione dei pazienti 
            // ******************************************************************************************************************
            inactiveGlobal5ASA = 0;
            inactiveGlobalTOPICA = 0;
            inactiveGlobalGCSOS = 0;
            inactiveGlobalIMM = 0;
            inactiveGlobalBIO = 0;

      
            activeGlobal5ASA = 0;
            activeGlobalTOPICA = 0;
            activeGlobalGCSOS = 0;
            activeGlobalBIO = 0;
            activeGlobalIMM = 0;
  
      
      
            GlobalPatients5ASA = 0;
            GlobalPatientsTOPICA = 0;
            GlobalPatientsGCSOS = 0;
            GlobalPatientsBIO =0;
            GlobalPatientsIMM = 0;

      
            inactiveGlobalPatientsArray = [];
            activeGlobalPatientsArray = [];
            inactivePatientsGlobal = [];
            // ******************************************************************************************************************
            // bar chart dei pazienti 
            // ******************************************************************************************************************
            public barChartLabelsGlobalInactive = ['5-ASA-OS', 'TOPICA','GCS-OS','IMM.','BIO.'];
            public barChartTypeGlobalInactive = 'horizontalBar';
            public barChartLegendGlobalInactive = true;
            public barChartDataGlobalInactive = [
              {
                data: this.activeGlobalPatientsArray, label: 'Attivi', backgroundColor: ['teal', 'teal','teal', 'teal','teak'],
                hoverBackgroundColor: ['#066','066', '#066','#066','#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
              },
              {
                data: this.inactiveGlobalPatientsArray, label: 'Inattivi', backgroundColor: ['orangered', 'orangered','orangered','orangered','orangered'],
                hoverBackgroundColor: ['#cc3700','cc3700','#cc3700','cc3700','cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
              }];
            
      
      
            // constructor
            constructor(private store: Store<AppState>,
                        private doctorService: DoctorService,
                        private snackBar: MatSnackBar) {
              this.getAuthState = this.store.select(selectAuthState);
              this.getDoctorState = this.store.select(selectDoctorState);
            }
            // ******************************************************************************************************************
            // metodo all'inizio
            ngOnInit(): void {
              this.subscription7 = this.getAuthState.subscribe((state) => {
                this.isAuthenticated = state.isAuthenticated;
                this.user = JSON.parse(localStorage.getItem('user'));
                this.errorMessage = state.errorMessage;
                this.retrieveGlobalInactive5ASA_Active();
              });
            }
            ngOnDestroy(): void {
              this.subscription1.unsubscribe();
              this.subscription2.unsubscribe();
              this.subscription3.unsubscribe();
              this.subscription4.unsubscribe();
              this.subscription5.unsubscribe();
              this.subscription6.unsubscribe();
              this.subscription7.unsubscribe();

            }
            // ******************************************************************************************************************
            // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
            // e in standard e poi tutti
            // i pazienti in ogni categoria per poter calcolare gli attivi
            // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
    
            retrieveGlobalInactive5ASA_Active() {
              this.subscription1 = this.doctorService.getInactiveActiveTherapyNumber("therapy5ASAOS").subscribe(npatients => {
                this.inactiveGlobal5ASA = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobal5ASA); // riempio il vettore del bar chart con standard
                this.retrieveGlobalInactiveTOPICA_Active();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
            retrieveGlobalInactiveTOPICA_Active() {
              this.subscription2 = this.doctorService.getInactiveActiveTherapyNumber("therapyTOPICA").subscribe(npatients => {
                this.inactiveGlobalTOPICA = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalTOPICA); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactiveGCSOS_Active();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
  
            retrieveGlobalInactiveGCSOS_Active() {
              this.subscription3 = this.doctorService.getInactiveActiveTherapyNumber("therapyGCSOS").subscribe(npatients => {
                this.inactiveGlobalGCSOS = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalGCSOS); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactiveIMM_Active();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }

            retrieveGlobalInactiveIMM_Active() {
              this.subscription4 = this.doctorService.getInactiveActiveTherapyNumber("therapyIMM").subscribe(npatients => {
                this.inactiveGlobalIMM = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalIMM); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalInactiveBIO_Active();
  
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
    
            retrieveGlobalInactiveBIO_Active() {
              this.subscription5 = this.doctorService.getInactiveActiveTherapyNumber("therapyBIO").subscribe(npatients => {
                this.inactiveGlobalBIO = parseInt(npatients.toString());
                this.inactiveGlobalPatientsArray.push(this.inactiveGlobalBIO); // riempio vettore del bar-chart con telemedicina
                this.retrieveGlobalActiveTherapy();
    
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
          
            retrieveGlobalActiveTherapy() {
              this.subscription6 = this.doctorService.getGlobalActiveTherapyLoginExistsNumber().subscribe(num => {
                this.GlobalPatients5ASA = num[0];
                this.GlobalPatientsTOPICA = num[1];
                this.GlobalPatientsGCSOS = num[2];
                this.GlobalPatientsIMM = num[3];
                this.GlobalPatientsBIO = num[4];
    
                this.activeGlobal5ASA = this.GlobalPatients5ASA - this.inactiveGlobal5ASA;
                this.activeGlobalPatientsArray.push(this.activeGlobal5ASA); // riempio il vettore del bar chart con standard           
                this.activeGlobalTOPICA = this.GlobalPatientsTOPICA - this.inactiveGlobalTOPICA;
                this.activeGlobalPatientsArray.push(this.activeGlobalTOPICA); // riempio il vettore del bar chart con telemedicina
                this.activeGlobalGCSOS = this.GlobalPatientsGCSOS - this.inactiveGlobalGCSOS;
                this.activeGlobalPatientsArray.push(this.activeGlobalGCSOS); // riempio il vettore del bar chart con standard           
                this.activeGlobalIMM = this.GlobalPatientsIMM - this.inactiveGlobalIMM;
                this.activeGlobalPatientsArray.push(this.activeGlobalIMM); // riempio il vettore del bar chart con standard           
                this.activeGlobalBIO = this.GlobalPatientsBIO - this.inactiveGlobalBIO;
                this.activeGlobalPatientsArray.push(this.activeGlobalBIO); // riempio il vettore del bar chart con standard           
                this.canvasSetting();
              }, error => {
                if (error.status === 500) {
                  localStorage.setItem('expirationTime', '0');
                  console.log('SESSIONE SCADUTA');
                  location.reload();
                }
              });
            }
           
            canvasSetting() {
                this.canvas = document.getElementById('myChartInactiveActiveTherapy') as HTMLCanvasElement;
                this.ctx = this.canvas.getContext('2d');
                this.myChartInactivePatients = new Chart(this.ctx, {
                  type: this.barChartTypeGlobalInactive,
                  data: {
                    labels: this.barChartLabelsGlobalInactive,
                    datasets: this.barChartDataGlobalInactive,
                  },
                  options: {
                    maintainAspectRatio: true,
                    responsive: true,
      
                    scales: {
                      xAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                      yAxes: [{
                        display: true,
                        stacked: false,
                        ticks: {
                          fontSize: 12,
                          fontStyle: 'bold',
                          fontFamily: 'Helvetica',
                          fontColor: '#006192'
                        }
                      }],
                    },
                    legend: {
                     
                      display: true,
                      position: 'top',
                      labels: {
                        usePointStyle: true,
                        fontColor: '#006192',
                        fontSize: 18,
                        fontFamily: 'Helvetica',
                      }
                    },
                    tooltips: {
                      // content: '{pathology}: {number}',
                      backgroundColor: '#1c1c1c',
                      bodyFontSize: 18,
                      titleFontSize: 18,
                      cornerRadius: 5,
                      caretPadding: 10
                    },
                    title: {
                      display: true,
                      text: "N° di utenti attivi/inattivi",
                      fontColor: '#006192',
                      fontSize: 20,
                      fontFamily: 'Helvetica',
                    },
                    hover: {
                      mode: 'nearest',
                      intersect: true
                    }
                  }
                });
                } // dopo aver ottenuto tutti i dati creo il bar chart
            
          }
          